// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 62 ? "Charpter" : chunkId) + "." + {"62":"c9bcb350","162":"c8643c6d","786":"7939cbae"}[chunkId] + ".css";
};